import { Component, signal, effect } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { PageHeader } from '../../../../shared/components/page-header/page-header';
import { BlogItem } from '../../../../shared/components/blog-item/blog-item';
import { NewsSidebar } from '../../../../shared/components/news-sidebar/news-sidebar';
import { BlogService, BlogPost } from '../../../../shared/services/blog.service';

@Component({
  selector: 'app-news-page',
  imports: [PageHeader, BlogItem, NewsSidebar],
  templateUrl: './news-page.html',
  styleUrl: './news-page.scss',
})
export class NewsPage {
  private blogService = new BlogService();
  
  breadcrumbs = [
    { label: 'Home', route: '/' },
    { label: 'Noticias', isActive: true }
  ];

  posts = signal<BlogPost[]>([]);
  currentPage = signal(1);
  totalPages = signal(1);
  pageSize = 6;
  isLoading = signal(false);

  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Noticias empresariales en Bolivia| Análisis y tendencias');
    this.metaService.updateTag({ name: 'description', content: 'Noticias empresariales en Bolivia con análisis y perspectiva estratégica. Información clave para entender el entorno y tomar mejores decisiones.' });
    this.metaService.updateTag({ name: 'keywords', content: 'Noticias empresariales en Bolivia, actualidad empresarial Bolivia, tendencias empresariales, análisis empresarial Bolivia, economía y empresas Bolivia, gestión empresarial noticias' });
    this.metaService.updateTag({ property: 'og:title', content: 'Noticias empresariales en Bolivia| Análisis y tendencias' });
    this.metaService.updateTag({ property: 'og:description', content: 'Noticias empresariales en Bolivia con análisis y perspectiva estratégica. Información clave para entender el entorno y tomar mejores decisiones.' });
    this.metaService.updateTag({ property: 'og:image', content: 'https://web.dev.consultorio.biz/images/SEO/Noticias.png' });

    this.loadPosts();
    
    // Watch for page changes and reload posts
    effect(() => {
      this.loadPosts();
    });
  }

  async loadPosts() {
    this.isLoading.set(true);
  
    const result = await this.blogService.getPaginatedPostsFromApi(this.currentPage(), this.pageSize);
    this.posts.set(result.posts);
    this.totalPages.set(result.totalPages);
    
    this.isLoading.set(false);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages()) {
      this.currentPage.set(page);
      this.scrollToTop();
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
